/**
 * Blue 600ms box-shadow pulse on a committed control (Figma
 * "field-captured" feedback). Re-keying the wrapper restarts the CSS
 * animation on every commit — see `.field-flash` in styles.css.
 * Lives apart from field-row.tsx so that file stays components-only
 * (react-refresh constraint).
 */
import { useCallback, useState } from "react";

export function useBlurFlash(): { flashKey: number; flash: () => void } {
    const [flashKey, setFlashKey] = useState(0);
    const flash = useCallback(() => setFlashKey((n) => n + 1), []);
    return { flashKey, flash };
}
